import React from 'react';
import { Route, Routes } from 'react-router-dom';

import AuthLayout from 'components/layout/AuthLayout/AuthLayout';
import Layout from 'Layout';

import { authRoutes, privateRoutes } from './allRoutes';
import AuthProtected from './AuthProtected';

const RouteIndex = () => {
    return (
        <React.Fragment>
            <Routes>
                {privateRoutes.map((route: any, idx: number) => (
                    <Route
                        key={idx}
                        path={route.path}
                        element={
                            <AuthProtected>
                                <Layout>
                                    <route.component />
                                </Layout>
                            </AuthProtected>
                        }
                    />
                ))}
                {authRoutes.map((route: any, idx: number) => (
                    <Route
                        path={route.path}
                        key={idx}
                        element={
                            <AuthLayout>
                                <route.component />
                            </AuthLayout>
                        }
                    />
                ))}
            </Routes>
        </React.Fragment>
    );
};

export default RouteIndex;

// "6": "^0.0.1",
// "@ckeditor/ckeditor5-build-classic": "^41.0.0",
// "@ckeditor/ckeditor5-editor-balloon": "^41.0.0",
// "@ckeditor/ckeditor5-react": "^6.2.0",
// "@fullcalendar/core": "^6.1.10",
// "@fullcalendar/daygrid": "^6.1.10",
// "@fullcalendar/interaction": "^6.1.10",
// "@fullcalendar/list": "^6.1.10",
// "@fullcalendar/multimonth": "^6.1.10",
// "@fullcalendar/react": "^6.1.10",
// "@tanstack/match-sorter-utils": "^8.11.7",
// "@tanstack/react-table": "^8.11.7",
// "@testing-library/jest-dom": "^6.3.0",
// "@testing-library/react": "^14.1.2",
// "@testing-library/user-event": "^14.5.2",
// "@types/react-color": "^3.0.11",
// "@types/react-copy-to-clipboard": "^5.0.7",

// "@types/react-dual-listbox": "^2.2.5",
// "@types/react-flatpickr": "^3.8.11",
// "apexcharts": "^3.45.2",
// "axios-mock-adapter": "^1.22.0",
// "cleave.js": "^1.6.0",
// "firebase": "^10.7.2",
// "flatpickr": "^4.6.13",
// "google-maps-react": "^2.0.6",
// "leaflet": "^1.9.4",
// "lightbox.js-react": "^0.9.9",
// "lucide-react": "^0.315.0",
// "plyr-react": "^5.3.0",
// "prismjs": "^1.29.0",
// "react-apexcharts": "^1.4.1",
// "react-color": "^2.19.3",
// "react-copy-to-clipboard": "^5.1.0",
// "react-countup": "^6.5.0",
// "react-dropzone": "^14.2.3",
// "react-dual-listbox": "^6.0.1",
// "react-flatpickr": "^3.10.13",
// "react-leaflet": "^4.2.1",
// "react-popper": "^2.3.0",
// "react-select": "^5.8.0",
// "react-sweetalert2": "^0.6.0",
// "react-toastify": "^9.1.3",
// "react-tooltip": "^5.26.0",

// "swiper": "^11.0.5",
// "web-vitals": "^3.5.1",
// "yet-another-react-lightbox": "^3.16.0",
